import React from 'react'
import {Message as SemanticMessage} from 'semantic-ui-react'
import errors from './config'

export const Message = ({ header, message, ...rest }) => {
  return (
    <SemanticMessage {...rest}>
      { header && (
        <SemanticMessage.Header>{header}</SemanticMessage.Header>
      )}
      <p>{message}</p>
    </SemanticMessage>
  )
}


export const getApiResponseErrorMessage = ({ key, prefix = '', sufix = '', def = true }) => {

  if (errors.hasOwnProperty(key))
    return `${prefix} ${errors[key]} ${sufix}`

  return def

}